import {LinkedListNode} from './linked-list-node';
export class LinkedList<T extends LinkedListNode> {

  head: T;

  constructor(head: T) {
    this.head = head;
  }

  addAfter(nodeToAdd: T, nodeInPlace: T): void {

    //Set the pointers for nodeToAdd
    nodeToAdd.nextNode = nodeInPlace.nextNode;
    nodeToAdd.previousNode = nodeInPlace;

    //Set the pointers for nodes in place
    if (nodeInPlace.nextNode != null) {
      nodeInPlace.nextNode.previousNode = nodeToAdd;
    }
    nodeInPlace.nextNode = nodeToAdd;
  }

  addBefore(nodeToAdd: T, nodeInPlace: T): void {

    //Set the pointers for nodeToAdd
    nodeToAdd.previousNode = nodeInPlace.previousNode;
    nodeToAdd.nextNode = nodeInPlace;

    //Set the pointers for nodes in place
    if (nodeInPlace.previousNode != null) {
      nodeInPlace.previousNode.nextNode = nodeToAdd;
    }
    nodeInPlace.previousNode = nodeToAdd;

    if (this.head === nodeInPlace) {
      this.head = nodeToAdd;
    }
  }

  contains(node: LinkedListNode): boolean {
    let itr: LinkedListNode = this.head;

    while (itr != null && itr !== node) {
      itr = itr.nextNode;
    }

    return itr != null;
  }

  /**
   * Loops over every element in the list.
   * If the callback returns true, the loop will stop.
   * @param callback
   */
  forEach(callback: (value: T) => boolean|void): void {
    let itr: T = this.head;
    while (itr != null) {
      if (callback(itr) !== true) {
        itr = <T>itr.nextNode;
      }
    }
  }

  removeNode(node: LinkedListNode): void {
    //Removing the head isn't supported at this time.
    if (node === this.head) {
      return;
    }

    if (node.previousNode != null) {
      node.previousNode.nextNode = node.nextNode;
    }
    if (node.nextNode != null) {
      node.nextNode.previousNode = node.previousNode;
    }

    delete node.previousNode;
    delete node.nextNode;
  }
}
